import React from 'react';
import { Helmet } from 'react-helmet';
import { apiGet } from '../../helper/helperApi';
import { handleException } from '../../helper/helperError';
import { useAuth } from '../components/authProvider';
import AppLayoutTitle from './appLayoutTitle';
import ComStatCard from './../components/comStatCard';
import ChartEmailVolumeLTM from './../components/chartEmailVolumeLTM';
import ChartDomainTrafficByPeriod from './../components/chartDomainTrafficByPeriod';
import ComLoading from '../components/comLoading';

const AppOverview = () => {
    const [dataset, setDataset] = React.useState(null);
    const [activeFilter, setActiveFilter] = React.useState('today');
    const { authUser } = useAuth();

    React.useEffect(() => {
        apiGet('/reports/getOverviewData/' + activeFilter)
            .then(response => (setDataset(response?.data || null)))
            .catch(ex => handleException(ex, "Failed to fetch overview data"));
    }, [activeFilter]);

    if (!dataset) {
        return <ComLoading message="Loading dashboard data..." />;
    }

    return <>
        <Helmet><title>Overview | Sparkling Email</title></Helmet>
        <>
            <AppLayoutTitle title="Dashboard Overview" buttons={
                <div className="btn-group btn-group-sm" role="group" aria-label="Timeframe filter">
                    <button type="button" className={`btn ${activeFilter === 'today' ? 'btn-dark' : 'btn-outline-secondary'}`} onClick={() => setActiveFilter('today')}><i className="fa fa-calendar-day me-1"></i>Today</button>
                    <button type="button" className={`btn ${activeFilter === 'week' ? 'btn-dark' : 'btn-outline-secondary'}`} onClick={() => setActiveFilter('week')}><i className="fa fa-calendar-week me-1"></i>This Week</button>
                    <button type="button" className={`btn ${activeFilter === 'month' ? 'btn-dark' : 'btn-outline-secondary'}`} onClick={() => setActiveFilter('month')}><i className="fa fa-calendar-alt me-1"></i>This Month</button>
                    {authUser?.isSuperAdmin === true &&
                        <button type="button" className={`btn ${activeFilter === 'year' ? 'btn-dark' : 'btn-outline-secondary'}`} onClick={() => setActiveFilter('year')}><i className="fa fa-calendar-year me-1"></i>This Year</button>}
                </div>
            } />
            <div className="container-fluid px-3 py-3">
                <div className="row g-3 mb-4">
                    {dataset.kpi.map((item, idx) => (<ComStatCard
                        key={idx}
                        tooltip={item?.tooltip}
                        label={item?.label}
                        value={item?.value}
                        trendDirection={item?.trendDirection}
                        trendChange={item?.trendChange}
                        trendLabel={item?.trendLabel}
                        icon={item?.icon}
                        color={item?.color}
                        url={item?.url}
                        size="large"
                    />))}
                </div>
                <div className="row g-3 mb-4">
                    {dataset.stats.map((item, idx) => (<ComStatCard
                        key={idx}
                        tooltip={item?.tooltip}
                        label={item?.label}
                        value={item?.value}
                        trendDirection={item?.trendDirection}
                        trendChange={item?.trendChange}
                        trendLabel={item?.trendLabel}
                        icon={item?.icon}
                        color={item?.color}
                        url={item?.url}
                        size="small"
                    />))}
                </div>
                <div className="row g-3 mb-4">
                    <div className="col-12 col-xl-8"><ChartEmailVolumeLTM /></div>
                    <div className="col-12 col-xl-4"><ChartDomainTrafficByPeriod period={activeFilter} /></div>
                </div>
            </div>
        </>
    </>
};

export default AppOverview;